/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-22 13:41:31
 * @LastEditors: K
 * @LastEditTime: 2022-09-09 17:59:09
 */
import { unwrapResult } from '@reduxjs/toolkit';
import { Row, Col, Table, Button, Form, Input, Space, Cascader as Cascaded, Select, Spin, } from 'antd';
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../../app/store';
import { BeautyClinicMedicalRecordNumLine, MedicalRecordNumLine, MoneyLine, MouthMedicalRecordNumLine, PatientsNumberLine, PenNumberLine, RecipeNumLine, SeeDoctorLine, TcmMedicalRecordNumLine, UniversalMedicalRecordNumLine, UploadOutlined } from '../../../compnents/icons/Icons';
import { getBackgroundColor, getOrganizationPlaneName } from '../../../models/monitoring';
import { UpdateTime } from '../components/time';
import { getOutpatienData, getOutpatienDataPie, getTableList, getTendencyChart } from '../monitoringPageSlice';
import styles from '../monitoringTab.module.css'
import * as echarts from 'echarts';
import { CaretDownFilled, SearchOutlined } from '@ant-design/icons';
import { stringTrim } from '../../../utils/StringUtils';
import { getAllList } from '../../tenant/tenantSlice';
import { ThemeContext } from '../../../theme/ThemeContext';
import { echartBre, echartsLine, echartsPie } from '../../../models/echartsData';
import moment from 'moment';
interface OutpatientDataProps {
  state: string
}

export const OutpatientData = ({ state }: OutpatientDataProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const lineRef = useRef<HTMLDivElement>(null)

  const barRefA = useRef<HTMLDivElement>(null)

  const barRefB = useRef<HTMLDivElement>(null)

  const list = [
    { name: 'patientNum', color: 1, icon: <PatientsNumberLine /> },
    { name: 'seeingNum', color: 2, icon: <SeeDoctorLine /> },
    { name: 'settlementNum', color: 1, icon: <PenNumberLine /> },
    { name: 'settlementMoney', color: 2, icon: <MoneyLine /> },
    { name: 'recipeNum', color: 1, icon: <RecipeNumLine /> },
    { name: 'medicalRecordNum', color: 1, icon: <MedicalRecordNumLine /> },
    { name: 'universalMedicalRecordNum', color: 2, icon: <UniversalMedicalRecordNumLine /> },
    { name: 'tcmMedicalRecordNum', color: 3, icon: <TcmMedicalRecordNumLine /> },
    { name: 'mouthMedicalRecordNum', color: 4, icon: <MouthMedicalRecordNumLine /> },
    { name: 'beautyClinicMedicalRecordNum', color: 1, icon: <BeautyClinicMedicalRecordNumLine /> },
  ]

  const [page, setPage] = useState([])

  const pieRefA = useRef<HTMLDivElement>(null)

  const pieRefB = useRef<HTMLDivElement>(null)

  const pieRefC = useRef<HTMLDivElement>(null)

  const pieRefD = useRef<HTMLDivElement>(null)

  const pieRefE = useRef<HTMLDivElement>(null)

  const [productPriceModalList, setProductPriceModalList] = useState([
    { name: '全部', id: 1 },
    { name: '卫生院', id: 2 },
    { name: '药店', id: 3 },
  ])   //产品价格表弹窗数据

  const [dataNum, setDataNum] = useState(0)    //全部or好医点or聚网

  const [lineChartData, setLineChartData] = useState<any>()    //近一年就诊趋势图数据

  const [allList, setAllList] = useState<any[]>()   //省市数据

  const [dateList, setDateList] = useState<any[]>([])   //统计时间数据

  const [params, setParams] = useState({})

  const [dataList, setDataList] = useState<any>({})   //数据看板数据

  const [listLoading, setListLoading] = useState(false) // 数据看板 loading

  const [pieChartData, setPieChartData] = useState<any>({})    //饼状图


  const [topBreChartData, setTopBreChartData] = useState<any>()    //柱状图

  const [bottomBreChartData, setBottomBreChartData] = useState<any>()   //柱状图

  const [aa, setAa] = useState(false)   //柱状图

  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
  }

  useEffect(() => {   //获取省市数据
    dispatch(getAllList())
      .then(unwrapResult)
      .then((t: any) => {
        setAllList(t)
      })

    for (let i = 0; i <= 12; i++) {  //统计时间
      setDateList((el) => {
        return [...el,
        {
          time: moment().subtract(i, 'months').format('YYYY-MM'),
          id: i
        }]
      })
    }
  }, [])


  const pieList = [{
    id: 0,
    el: pieRefA,
    name: 'patientSexVO',
  }, {
    id: 1,
    el: pieRefB,
    name: 'patientAgeVO',
  }, {
    id: -1,
    name: 'liabilityVOList',
  },
  {
    id: 2,
    el: pieRefC,
    name: 'medicalPieChartVOS',
  }, {
    id: 3,
    el: pieRefD,
    name: 'recipePieChartVO',
  }, {
    id: 4,
    el: pieRefE,
    name: 'settlementAmountPieChartVO',
  }]

  const barList = [{
    id: 3,
    el: barRefA,
    data: topBreChartData,
    title: 'medicalRecords'
  }, {
    id: 4,
    el: barRefB,
    data: bottomBreChartData,
    title: 'settlement'
  }]

  const getData = () => {   // 数据看板
    setListLoading(true)
    dispatch(getOutpatienData({ ...params, type: dataNum }))
      .then(unwrapResult)
      .then((t: any) => setDataList(t))
      .finally(() => setListLoading(false))
  }

  const getePieChart = () => { //饼状图
    dispatch(getOutpatienDataPie({ ...params, type: dataNum }))
      .then(unwrapResult)
      .then((t: any) => setPieChartData(t))
  }

  const getDoctorLineChart = (num: number) => { //近一年就诊趋势图
    dispatch(getTendencyChart({
      trendChartType: num,
      type: dataNum
    }))
      .then(unwrapResult)
      .then((t: any) => {
        if (num == 2) {
          setLineChartData(t)
        } else if (num == 3) {
          setTopBreChartData(t)
        } else if (num == 4) {
          setBottomBreChartData(t)
        }
      })
  }

  useEffect(() => {
    dispatch(getTableList())  //表格数据
      .then(unwrapResult)
      .then((t: any) => {
        setPage(t)
      })

  }, [])


  useEffect(() => {   // 全部、好医点、聚网
    getDoctorLineChart(2)
    barList.forEach(v => {
      getDoctorLineChart(v.id)
    })
  }, [dataNum])

  useEffect(() => {
    getData()
    getePieChart()
  }, [params, dataNum])

  useEffect(() => {

    setTimeout(() => {
      pieList.forEach((v) => {
        v.id >= 0 && pieEcharts(v.el, v.name)
      })
      barList.forEach(v => {
        barEcharts(v.el, v.id, v.data, v.title)
      })
      lineEcharts()
    }, 200)
  }, [pieRefA, lineRef, lineChartData, pieChartData, topBreChartData, bottomBreChartData])

  const pieEcharts = (ref: any, name: string) => {   //饼状图
    if (!ref.current) return
    const myChart = echarts.init(ref?.current);

    if (!pieChartData[name]?.length) {
      myChart.dispose()
    }
    myChart.setOption(echartsPie(pieChartData[name], 'name', 'val', true, name));
  }

  const lineEcharts = () => {   //折线图
    if (!lineRef.current) return
    const myChart = echarts.init(lineRef?.current);
    myChart.setOption(echartsLine(lineChartData, true, 'visitTrendChart', 2));
  }

  const barEcharts = (ref: any, id: number, data: any, title: string) => {  //柱状图
    if (!ref.current) return
    const myChart = echarts.init(ref?.current);
    myChart.setOption(echartBre(data, id, title));

  }

  useEffect(() => {   //缓存tab 栏
    sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])
  return (
    <div className={styles.containers}>
      <div className={styles.content}>
        <UpdateTime time={''} select={(v) => setDataNum(v)} />
        {/* 筛选查询区域 */}
        <Form
          form={form}
          autoComplete='off'
          onFinish={(values) => {
            setParams({
              ...params,
              ...values,
              startTime: values.time ? moment(values.time).startOf("month").format("YYYY-MM-DD") : undefined,
              endTime: values.time ? moment(values.time).endOf('month').format("YYYY-MM-DD") : undefined,
              time: undefined,
              provinceCode: values.area?.slice(0, 1)[0],
              cityCode: values.area?.slice(1, 2)[0],
              countyCode: values.area?.slice(2, 3)[0],
              area: undefined,

            })
          }}
        >
          <Row
            align='middle'
            style={{ margin: '10px 0 20px' }}
          >
            <Space>
              <Form.Item name='keyWord' noStyle getValueFromEvent={stringTrim}>
                <Input
                  allowClear
                  placeholder='请输入机构名称'
                  prefix={<SearchOutlined />}

                  onChange={form.submit}
                />
              </Form.Item>

              <Form.Item name='area' noStyle>
                <Cascaded
                  loadData={loadData}
                  changeOnSelect
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  options={allList}
                  style={{ width: '13rem' }}
                  onChange={form.submit}
                  placeholder='请选择省市区'
                />
              </Form.Item>
              <Form.Item name='time' noStyle>
                <Select
                  placeholder='统计时间-全部'
                  style={{ width: '10rem' }}
                  onChange={form.submit}
                  allowClear
                >
                  {dateList.map((item: any) => <Select.Option key={item.id} value={item.time}>{item.time}</Select.Option>)}
                </Select>
              </Form.Item>

            </Space>
            <Button type='primary' onClick={form.submit} style={{ marginLeft: 60 }}>
              查询
            </Button>
          </Row>
        </Form>
        <Spin spinning={listLoading} >
        <Row gutter={[20, 20]} className={styles.planContainer}>
          {
            list.map((v: any, i: number) => (
              <Col key={v.name} flex={'20%'} >
                <div className={`${styles.planItem} ${styles.layout}`}>
                  <div className={styles.planIcon}
                    style={{ backgroundColor: getBackgroundColor(v.color) }}>
                    {v.icon}
                  </div>
                  <div className={styles.planData}>
                    {getOrganizationPlaneName(v.name)}
                    <div>
                      {dataList[v.name]}
                    </div>
                  </div>
                </div>
              </Col>
            ))
          }
        </Row>
        </Spin>
        <Row gutter={[20, 20]} className={`${styles.planContainer}`}>
          {
            pieList.map((v, i) => (
              v.id >= 0 ? (
                <Col span={8} key={i} style={{ height: 320 }}>
                  <div className={styles.layout}>
                    <div ref={v.el} className={styles.echartsPie}></div>
                  </div>
                </Col>
              ) : (
                  <Col span={8}>
                    <div className={` ${styles.layout}`} style={{ height: 320 }}>
                      <UpdateTime titleType={'liabilityVOList'} showSelect={false} />
                    <Table
                      className={styles.table}
                      scroll={{ y: 200 }}
                        dataSource={pieChartData?.liabilityVOList}
                      pagination={false}
                      columns={[
                        {
                          title: '疾病名称',
                          dataIndex: 'name',
                          key: 'name',
                          align: 'center',
                          width: 100
                        },

                        {
                          title: '次数',
                          dataIndex: 'val',
                          key: 'val',
                          align: 'center',
                          width: 100
                        },
                      ]}
                    />
                  </div>
                </Col>
              )
            ))
          }
        </Row >
        <Row className={`${styles.planContainer}`}>
          <Col flex={1}>
            <div className={styles.layout}>
              <div ref={lineRef} className={styles.echartsLine}></div>
            </div>
          </Col>
        </Row>
        {
          barList.map(v => (
            <Row key={v.id} className={`${styles.planContainer}`}>
              <Col flex={1}>
                <div className={styles.layout}>
                  <div ref={v.el} className={styles.echartsLine}></div>
                </div>
              </Col>
            </Row>
          ))
        }
      </div >
    </div >
  );
}

